module.exports = __webpack_public_path__ + "00_hair.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/00_hair.png
// module id = zQNp
// module chunks = 0